module.exports = __webpack_public_path__ + "static/media/sd.808944c3.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/sd.svg
// module id = 1026
// module chunks = 0